function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing ${name}. Run "npm run deploy:infra" and then "node scripts/write-env.mjs" to regenerate frontend/.env.`,
    );
  }
  return value;
}

export const config = {
  apiUrl: required('VITE_API_URL', import.meta.env.VITE_API_URL).replace(/\/$/, ''),
  cognitoAuthority: required('VITE_COGNITO_AUTHORITY', import.meta.env.VITE_COGNITO_AUTHORITY),
  cognitoClientId: required('VITE_COGNITO_CLIENT_ID', import.meta.env.VITE_COGNITO_CLIENT_ID),
  cognitoDomain: required('VITE_COGNITO_DOMAIN', import.meta.env.VITE_COGNITO_DOMAIN).replace(/\/$/, ''),
  // Deliberately not a build-time value. The same bundle is served under the
  // custom domain and under *.cloudfront.net, and the OAuth state is stored per
  // origin - baking in one host makes the login fail from the other with
  // "No matching state found in storage". Every origin the app is served from is
  // registered as a Cognito callback URL.
  redirectUri: window.location.origin,
};
